<div fxLayout="column" fxLayoutAlign="space-between center" fxFlex>
  <div fxLayout fxLayoutAlign="center center" class="min-height-90">
    <div fxLayout="column" fxLayoutAlign="center center" class="img-wrapper">
      <img
        [hidden]="loading.image"
        [@rotatedState]='state'
        src="{{data.imageUrl}}"
        (load)="loadingImage()"
        (error)="imageUrlError($event)"
        class="img">          

      <div 
        *ngIf="!loading.image && loading.error"
        fxLayoutAlign="center center" 
        class="padding-top-10">
        {{ 'MSG_IMG_NOT_FOUND' | translate }}
      </div>
    </div>
  
    <div fxLayout fxFlex *ngIf="loading.image">
      <mat-spinner color="primary" mode="indeterminate" [diameter]="65"></mat-spinner>
    </div>
  </div>

  <div fxFlex></div>

  <div
    fxLayout 
    class="rotate-wrapper"
    fxLayoutAlign="center center">
  
    <ng-container>
      <button mat-icon-button (click)="rotateLeft()" [disabled]="loading.image || loading.error">
        <mat-icon svgIcon="rotate-left" [matTooltip]="'LABEL_ROTATE_LEFT' | translate"></mat-icon>
      </button>      
    </ng-container>
  
    <ng-container>
      <button mat-icon-button (click)="rotateRight()" [disabled]="loading.image || loading.error">
        <mat-icon svgIcon="rotate-right" [matTooltip]="'LABEL_ROTATE_RIGHT' | translate"></mat-icon>
      </button>
    </ng-container>
  
    <ng-container>
      <button mat-icon-button (click)="dialogRef.close()">
        <span>{{ 'LABEL_CLOSE' | translate }}</span>
      </button>
    </ng-container>
  
  </div>
</div>